import React, { useEffect, useState, useRef } from 'react';
export function Interface() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({
        x: (e.clientX - window.innerWidth / 2) / 30,
        y: (e.clientY - window.innerHeight / 2) / 30
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  return <div ref={sectionRef} className="py-32 md:py-40 bg-mint-50/50 dark:bg-black/80 transition-colors duration-500" data-id="element-124">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-125">
        <div className="flex flex-col items-center gap-16" data-id="element-126">
          <div className={`text-center transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-10'}`} data-id="element-127">
            <h2 className="text-3xl md:text-4xl font-light mb-4" data-id="element-128">
              as simple as a{' '}
              <span className="text-mint-600 dark:text-mint-400" data-id="element-129">
                text message
              </span>
            </h2>
            <p className="text-black/60 dark:text-white/60 text-lg" data-id="element-130">
              clean interface. clear answers. no spreadsheets required.
            </p>
          </div>
          <div className={`w-full max-w-xs transition-all duration-1000 delay-300 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{
          transform: isVisible ? `translate(${mousePosition.x}px, ${mousePosition.y}px)` : '',
          transition: 'transform 0.5s ease-out'
        }} data-id="element-131">
            <div className="relative" data-id="element-132">
              <div className="absolute -inset-4 bg-gradient-to-r from-mint-400/20 to-mint-500/10 blur-xl rounded-3xl opacity-50" data-id="element-133" />
              <div className="relative rounded-3xl overflow-hidden border border-black/10 dark:border-white/10 shadow-2xl" data-id="element-134">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nexWUY31GRsWQBwiXiBxKe/Chat.png" alt="Caltalk chat interface showing meal recommendations" className="w-full h-auto" data-id="element-135" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}